import React, { useState, useEffect } from 'react';
import { FormspreeProvider } from '@formspree/react';
import Cookies from 'js-cookie';
import ContactForm from './components/ContactForm';
import EmbedPlaceholder from './components/EmbedPlaceholder';
import './App.css';

function App() {
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const storedName = Cookies.get('userName');
    const storedEmail = Cookies.get('userEmail');
    
    if (storedName && storedEmail) {
      setUserInfo({ name: storedName, email: storedEmail });
    }
  }, []);

  const handleFormSubmit = (formData) => {
    Cookies.set('userName', formData.name, { expires: 30 });
    Cookies.set('userEmail', formData.email, { expires: 30 });
    setUserInfo(formData);
  };

  const projectId = process.env.REACT_APP_FORMSPREE_PROJECT_ID;

  return (
    <FormspreeProvider project={projectId}>
      <div className="App">
        {userInfo ? (
          <EmbedPlaceholder userName={userInfo.name} />
        ) : (
          <ContactForm onSubmitSuccess={handleFormSubmit} />
        )}
      </div>
    </FormspreeProvider>
  );
}

export default App;